/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import gql from "graphql-tag";

// export const LIST_ASSETS = gql`
//     query Query($listAssetsSize: Int, $listAssetsOffset: Int) {
//         listAssets(size: $listAssetsSize, offset: $listAssetsOffset) {
//             pagination {
//                 nextOffset
//                 totalItems
//             }
//             results {
//                 item {
//                     assetGroup
//                     assetId
//                     name
//                     img
//                     category
//                     price
//                     symbol
//                     secondaryPrice
//                     secondarySymbol
//                     sold
//                 }
//             }
//         }
//     }
// `;

export const SHOWCASE_ASSETS = gql`
query GetAssets($filter: AssetFilter, $size: Int, $offset: Int) {
  getAssets(filter: $filter, size: $size, offset: $offset) {
    data {
      _id
      idx
      title
      subtitle
      serialNo
      type
      tokenGroup
      tag
      img
      category
      thumbnail
      price {
        type
        amount
        currency
        sale {
          salePrice
          saleEndDate
        }
        symbol
      }
      scAddress
      networkType
      entity {
        assets {
          imgs {
            height
            src
            thumbnail
            width
            asset_type
          }
          others {
            height
            src
            thumbnail
            width
            asset_type
          }
          videos {
            height
            src
            thumbnail
            width
            asset_type
          }
          allCombined {
            height
            src
            thumbnail
            width
            asset_type
          }
        }
      }
      media {
        type
        src
        thumbnail
      }
     state
    }
    currentPage
    pageSize
    totalCount
    totalPages
  }
}
`;
